if (document.querySelector('.faq-category--active')) {
  const hash = window.location.href.split('#')[1]

  if (hash) {
    document.querySelector('.faq-category--active').classList.remove('faq-category--active')

    document.querySelectorAll('.faq-category').forEach((el) => {
      const href = el.getAttribute('href')

      if (href === '#' + hash) {
        el.classList.add('faq-category--active')
      }
    })
  }
}

document.querySelectorAll('.faq-question-header').forEach((el) => {
  el.addEventListener('click', () => {
    const parent = el.parentElement
    const body = el.nextElementSibling

    if (parent && body) {
      const isOpen = parent.classList.contains('faq-question--active')

      // Rotate chevron
      parent.classList.toggle('faq-question--active')

      // Figure out height
      const height = isOpen ? 0 : body.scrollHeight
      body.setAttribute('style', `max-height:${height}px`)
    }
  })
})

document.querySelectorAll('.faq-category').forEach((el) => {
  el.addEventListener('click', function (e) {
    document.querySelector('.faq-category--active').classList.remove('faq-category--active')
    el.classList.add('faq-category--active')
  })
})
